<template>
  <v-app id="app">
    <CoreAppBar />

    <v-main>
      <v-fade-transition mode="out-in">
        <router-view></router-view>
      </v-fade-transition>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {
    CoreAppBar: () => import("./components/core/AppBar")
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/app.scss";
</style>
